import Vue from 'vue'
import Vuex from 'vuex'

import shared from '@/store/shared'

import profile from "@/store/profile";
import loggedUser from '@/store/loggedUser'
import chatSignalR from '@/store/chatSignalR'

import users from "@/store/users"
import settings from "@/store/settings"

import chats from '@/store/chats'

import dictionary from "@/store/dictionary/dictionary"

import client from "@/store/client/client"
import clientTicket from "@/store/clientTicket/ticket"
import executors from "@/store/executors"
import services from "@/store/services"
import serviceNotification from "@/store/serviceNotification"

import knowledgebase from "@/store/knowledgeBase/knowledgebase"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('@/assets/sidebar-1.jpg'),
    drawer: null,
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
  },
  actions: {},
  modules: {
    shared,
    profile,
    loggedUser,
    chatSignalR,
    settings,
    users,
    chats,

    dictionary,

    client,
    clientTicket,
    executors,
    services,
    serviceNotification,

    knowledgebase
  }
})
